import { AlertService } from '../../shared/services/alert.service';
import { OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Assessment } from "../../shared/models/assessment";
import { AssessmentService } from "../../shared/services/assessment.service";
var AssessmentNewComponent = /** @class */ (function () {
    function AssessmentNewComponent(_assessmentService, router, alertService, route) {
        this._assessmentService = _assessmentService;
        this.router = router;
        this.alertService = alertService;
        this.route = route;
        this._assessment = new Assessment();
        this._assessment.name = "Untitled";
    }
    AssessmentNewComponent.prototype.ngOnInit = function () {
    };
    Object.defineProperty(AssessmentNewComponent.prototype, "assessment", {
        get: function () {
            return this._assessment;
        },
        set: function (v) {
            this._assessment = v;
        },
        enumerable: true,
        configurable: true
    });
    AssessmentNewComponent.prototype.validateAssessment = function (assessment) {
        var errors = [];
        if (typeof assessment.uid != 'string'
            || assessment.uid.trim() == "") {
            errors.push("Unique id is missing");
        }
        if (typeof assessment.name != 'string'
            || assessment.name.trim() == "") {
            errors.push("Name is missing");
        }
        if (typeof assessment.description != 'string'
            || assessment.description.trim() == "") {
            errors.push("Description is missing");
        }
        return errors;
    };
    AssessmentNewComponent.prototype.save = function () {
        var _this = this;
        var errors = this.validateAssessment(this._assessment);
        if (errors.length) {
            this.alertService.error("Please correct the following errors: " + errors.join(".\n"), 3000);
            return;
        }
        console.log(this._assessment);
        this._assessmentService.createAssessment(this._assessment)
            .then(function () {
            _this.alertService.success("Assessment Saved!");
            // TODO: stephen figure out how to use the angular2 version of this instead of the raw setTimeout
            setTimeout(function () {
                _this.router.navigate(["../", _this._assessment.uid, "edit"], { relativeTo: _this.route, replaceUrl: true });
            }, 1500);
        })
            .catch(function (error) {
            if (error && error.code) {
                if (error.code === 'DUP_ENTRY') {
                    _this.alertService.error("An assessment already exists with that unique id.  Please try a different one");
                    return;
                }
            }
            _this.alertService.error("Error occurred in saving your assessment. Please try again.");
        });
    };
    return AssessmentNewComponent;
}());
export { AssessmentNewComponent };



// WEBPACK FOOTER //
// ./src/app/admin/assessment-new/assessment-new.component.ts.pre-build-optimizer.js